import React from "react";
import AllServices from "../fakeData/AllServices";
import "./../index.css";
import SingleService from "./SingleService";

const Services = () => {
  return (
    <section
      className="services-container freelance-container"
      name="services"
      id="services"
      data-aos="fade-up"
    >
      <div className="container">
        <div className="row align-items center justify-content-center">
          <div className="common pt-5">
            <h2 className="mainHeader mt-5">Open to Freelance / Contract Work</h2>
            <p className="mainContent">
              Outside of my full-time role, I occasionally take on freelance
              and contract projects. Here's what I can help you build.
            </p>
            <div className="commonBorder" />
          </div>
          <div className="row serviceRow" data-aos="fade-up">
            {AllServices.map((service) => (
              <SingleService key={service.id} service={service} />
            ))}
          </div>

          <div className="freelance-cta">
            <a
              href="https://wa.me/8801805486757"
              rel="noopener noreferrer"
              target="_blank"
            >
              <button className="button btn-outline mb-2">
                Let's Talk on WhatsApp
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
